module.exports = __webpack_public_path__ + "media/lobby_normal1.7c866b2f.mp3";